import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M20 20c1.1 0 2 .9 2 2s-.9 2-2 2H4c-1.1 0-2-.9-2-2s.9-2 2-2zM12 3c.75 0 1.43.47 1.69 1.17l4.25 11.31c.28.73-.26 1.52-1.05 1.52-.48 0-.91-.3-1.07-.76l-.99-2.82H9.18l-1.01 2.83c-.15.45-.58.75-1.06.75l-.1212-.0064c-.7144-.0766-1.194-.822-.9288-1.5136l4.25-11.31C10.57 3.47 11.25 3 12 3zm.06 2.6h-.12l-2.03 5.79h4.18z"
  }],
  circles: []
};
var FormatColorTextIcon = function FormatColorTextIcon(props) {
  return renderIcon(props, iconType);
};
export { FormatColorTextIcon };